import {
  store,
  deleteTokens,
  removeForceOffline,
  clearDeliveryInfo,
  deleteUserAccountInfo,
  deleteContractDeactivationStatus
} from "@redux"
import fetchFoodsInbackground from "./fetchFoodsInbackground"
import clearSiteData from "./clearSiteData"
import { userLogoutRefreshToken } from "services"

const logout = () => {
  userLogoutRefreshToken()

  fetchFoodsInbackground.stop()

  store.dispatch(deleteTokens())
  store.dispatch(clearDeliveryInfo())
  store.dispatch(deleteUserAccountInfo())
  store.dispatch(deleteContractDeactivationStatus())

  clearSiteData()

  localStorage.removeItem("at")
  localStorage.removeItem("rt")
  localStorage.setItem("forceOffline", "false")

  store.dispatch(removeForceOffline())
}

export default logout